/**
 * Banner permanente de simulación educativa. Fijo en la parte superior,
 * accesible con role=alert.
 */
export function SimBanner() {
  return (
    <div
      role="alert"
      className="sticky top-0 z-50 w-full border-b border-[var(--cale-warning-border)] bg-[var(--cale-warning-bg)] px-4 py-2 text-center text-xs font-semibold tracking-wide text-[var(--cale-ink)] sm:text-sm"
    >
      SIMULACIÓN EDUCATIVA · SIN CONEXIÓN A RUNT/SICOV · SIN VALIDEZ PARA TRÁMITES, EVALUACIONES NI CERTIFICACIONES
    </div>
  );
}
